import { render, staticRenderFns } from "./PrivacyRoot.vue?vue&type=template&id=7d7960a8"
import script from "./PrivacyRoot.vue?vue&type=script&lang=ts"
export * from "./PrivacyRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports